__turbopack_context__.v({
  "className": "archivo_8dce512f-module__S6nFWG__className",
});
